import { CareLineFields } from "../enums/CareLineFields";
import CareLine from "../models/core/careLine/CareLine";
import Category from "../models/core/careLine/Category";
import Exam from "../models/core/careLine/Exam";
import Procedure from "../models/core/careLine/Procedure";
import VitalSign from "../models/core/careLine/VitalSign";
import { getFormatObject, getMonthIntervalObject } from "./HelperFunctions";

export const insertElementIntoCareLine = (list: any[], element: any, index: number) => {
    //removendo da lista o elemento de índice index
    const removedList = [...list]
    const removedElement = removedList.splice(index, 1)
    //Inserindo elemento novo no lugar do antigo
    removedList.splice(index, 0, { ...element, 
      intervaloMeses: removedElement[0].intervaloMeses, 
      formato: removedElement[0].formato });

    return removedList;
}

export const insertIntervaloOrFormatoIntoCareLine = (list: any[], element: any, index: number, isIntervalo: boolean) => {
    
    const removedList = [...list]
    const removedElement = removedList.splice(index, 1)
    let elementToInsert = {}
    if (isIntervalo) {
      elementToInsert = { ...removedElement[0], intervaloMeses: element }
    } else {
      elementToInsert = { ...removedElement[0], formato: element }
    }
    removedList.splice(index, 0, elementToInsert);

    return removedList;
}  

export const removeFieldFromList = (list: any[], index: number)=>{
  const listCopy = [...list]
  
  listCopy.splice(index, 1)
  
  return listCopy;
}

export const removeEmptyObjectsFromList = (list: any[])=>{
  return list.filter(elem=>{
    return elem.id !== ''
  })
}

export const hasAnyEmptyObjectOnList = (list: any[])=>{
  const retorno: any[] = list.filter(elem=>{
    return elem.id === ''
  })

  return retorno.length > 0;
}

export const emptyObjectOnListIndex = (list: any[], hasIntervalo: boolean, hasFormato: boolean)=>{
  
  const index = list.findIndex((elem: any, index: number)=>{
    return elem.id === '' 
      || hasIntervalo? Object.keys(elem.intervaloMeses).length === 0 : false
      || hasFormato? Object.keys(elem.formato).length === 0 : false
  })

  return index
}

export const isFieldlistEmpty = (list: any[])=>{
  const filtered = removeEmptyObjectsFromList(list)

  return filtered.length === 0;
}

export const buildFieldList = (list: any, field: any)=>{
  const retorno: any[] = []
  list.forEach((item: any) => {
    if (item.id !== '' || Object.keys(item.formato).length !== 0 || Object.keys(item.intervaloMeses).length !== 0) {
      switch(field){
        case CareLineFields.Exame:
          retorno.push(new Exam().fromJSON({ id: item.id, intervaloMeses: item.intervaloMeses.id? Number(item.intervaloMeses.id) : null, formato: item.formato.nome }))
          break;
        case CareLineFields.Categoria:
          retorno.push(new Category().fromJSON({ id: item.id, intervaloMeses: item.intervaloMeses.id? Number(item.intervaloMeses.id) : null }))
          break;
        case CareLineFields.SinalVital:
          retorno.push(new VitalSign().fromJSON({ id: item.id, intervaloMeses: 0 }))
          break;
        case CareLineFields.Procedimento:
          retorno.push(new Procedure().fromJSON({ id: item.id, intervaloMeses: item.intervaloMeses.id? Number(item.intervaloMeses.id) : null }))
          break;
      }
    }
  })

  return retorno;
}


export const getExamsForEdit = (mainObject: any, allExams: any[]) => {
  const examsForEdit: any[] = []
  mainObject.exames.forEach((exam: any) => {
    const examFilteredList = allExams.filter(ex => {
      return ex.id === exam.id
    })
    if (examFilteredList.length > 0) {
      const examFiltered = examFilteredList[0];
      examsForEdit.push({ ...examFiltered, intervaloMeses: getMonthIntervalObject(exam.intervaloMeses), formato: getFormatObject(exam.formato) })
    }
  })

  return examsForEdit;
}

export const getCategoriesOrProceduresForEdit = (isCategory: boolean, mainObject: any, allCategories: any[], allProcedures: any[]) => {
  const categoriesOrProceduresForEdit: any[] = []
  let list: any[] = []
  let allItemsList: any[] = []
  if (isCategory) {
    list = [...mainObject.categorias]
    allItemsList = [...allCategories]
  } else {
    list = [...mainObject.procedimentos]
    allItemsList = [...allProcedures]
  }

  list.forEach((item: any) => {
    const filteredList = allItemsList.filter(data => {
      return data.id === item.id
    })
    if (filteredList.length > 0) {
      const filteredItem = filteredList[0];
      categoriesOrProceduresForEdit.push({ ...filteredItem, intervaloMeses: getMonthIntervalObject(item.intervaloMeses) })
    }
  })

  return categoriesOrProceduresForEdit;
}

export const getVitalSignsForEdit = (mainObject: any, allVitalSigns: any[]) => {
  const vitalSignsForEdit: any[] = []
  mainObject.sinaisVitais.forEach((vs: any) => {
    const vitalSignFilteredList = allVitalSigns.filter(ex => {
      return ex.id === vs.id
    })
    if (vitalSignFilteredList.length > 0) {
      const vitalSignFiltered = vitalSignFilteredList[0];
      vitalSignsForEdit.push({ ...vitalSignFiltered, intervaloMeses: getMonthIntervalObject(vs.intervaloMeses), formato: getFormatObject(vs.formato) })
    }
  })

  return vitalSignsForEdit;
}

export const fillCareLineObject = (exams: any[], categories: any[], vitalSigns: any[], procedures: any[], values: any, gender: any)=>{
  const exames: Exam[] = buildFieldList(exams, CareLineFields.Exame)
  const categorias: Category[] = buildFieldList(categories, CareLineFields.Categoria)
  const procedimentos: Procedure[] = buildFieldList(procedures, CareLineFields.Procedimento)
  const sinaisVitais: VitalSign[] = buildFieldList(vitalSigns, CareLineFields.SinalVital)

  const linhaCuidado = new CareLine().fromJSON({
    id: values.id,
    nome: values.nome,
    idadeMinima: Number(values.idadeInicial) === 0? null : Number(values.idadeInicial),
    idadeMaxima: Number(values.idadeFinal) === 0? null : Number(values.idadeFinal),
    sexo: gender.id,
    categorias: categorias,
    exames: exames,
    procedimentos: procedimentos,
    sinaisVitais: sinaisVitais
  })
  
  return linhaCuidado;
}

export const validateEmptyListItem = (list: any[])=>{
    const filteredList = list.filter(e=>{
      return e.id === '' || e.formato === null || e.intervaloMeses === null;
    })

    return filteredList.length === 0;
}

export const validateListHasAnyEmptyValue = (list: any, hasIntervalo: boolean, hasFormato: boolean)=>{

  const isFormatoEmpty = !hasFormato? false : list.filter((e: any)=>{
    return Object.keys(e.formato).length === 0
  }).length !== 0

  const isIntervaloEmpty = !hasIntervalo? false : list.filter((e: any)=>{
    return Object.keys(e.intervaloMeses).length === 0
  }).length !== 0;

  const isValueEmpty = list.filter((e: any)=>{
    return e.id === ''
  }).length !== 0;

  return isFormatoEmpty || isIntervaloEmpty || isValueEmpty;
}